import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import {
  IMovementHistoric,
  IMovements,
} from 'safe'
import {
  MovementTypes,
  SET_MOVEMENTS,
} from './actionTypes'
const server = process.env.REACT_APP_SERVER_URL

const setMovements = (items: IMovements): MovementTypes => ({
  type: SET_MOVEMENTS,
  payload: items,
})

export const fetchMovements =
  (
    querySearch: string[],
    paginationParams: string[] = []
  ): ThunkAction<Promise<void>, {}, {}, MovementTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, MovementTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        movements: IMovementHistoric[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/inventory/movement?${[
          ...querySearch,
          ...paginationParams,
        ].join('&')}`
      )

      console.log("VIENDO", response?.data)

      dispatch(
        //@ts-ignore
        setMovements({ movements: response.data.movements, numberOfPages: response.data.numberOfPages })
      )
    } catch (e) {
      throw e
    }
  }
